import React, { memo, useMemo } from 'react';
import { FiUserPlus } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import { CardPosition } from './CardPosition';

import icPodium from '@/assets/ic_podium.svg';
import { Button, Card } from '@/components';
import { PencilIcon } from '@/components/Navbar/Icons';
import { useIsLastMatchDay } from '@/hooks/useIsLastMatchDate';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import { FCupViewTeamResponse } from '@/types/friendCup';
import { cn } from '@/utils';

export const SidebarContentView: React.FC = memo(() => {
  const { tourneyData } = useTourney();
  const navigate = useNavigate();

  const tourney: FCupViewTeamResponse = tourneyData.tourney;

  const showInvite = useMemo(() => {
    return tourney?.fechaEqIncompleto && tourneyData.isOwner;
  }, [tourney?.fechaEqIncompleto, tourneyData.isOwner]);

  const showPending = useMemo(() => {
    return (
      tourney?.queAunNoAceptaste && tourney?.queAunNoAceptaste.length !== 0
    );
  }, [tourney?.queAunNoAceptaste]);
  const isLastMatchday = useIsLastMatchDay();

  return (
    <div className="lg:w-[426px]">
      <div
        className={cn('max-h-[190px] h-screen', {
          'max-h-[110px]':
            tourneyData.isOwner &&
            !tourney?.cantSolPendientes &&
            tourney?.fechasCmbVerEquipo2,
        })}
      >
        {showInvite && (
          <div
            className={cn(
              'flex flex-col justify-center items-center w-full h-full',
              { 'justify-start': !showPending }
            )}
          >
            <Button
              className="w-[332px] h-[50px]"
              type="button"
              variant="primary"
              onClick={() => {
                navigate(ROUTES.friendsCup.adminTeam);
              }}
            >
              <span className="flex items-center justify-center">
                <PencilIcon className="mr-2" />
                Administrar
              </span>
            </Button>
            <Button
              className="mt-3 w-[332px] h-[50px]"
              type="button"
              variant="secondary"
              onClick={() => {
                navigate(ROUTES.friendsCup.invite);
              }}
            >
              Invitar amigos
            </Button>
            {showPending && showInvite && (
              <Button
                className="mt-5 flex items-center space-x-3 underline-offset-4 font-semibold "
                disabled={isLastMatchday}
                type="button"
                variant="text"
                onClick={() => {
                  navigate(ROUTES.friendsCup.adminTeam);
                }}
              >
                <figure className="rounded-full bg-gdt-blue-light2 w-7 h-7 flex justify-center items-center">
                  <FiUserPlus />
                </figure>
                <p>
                  Tenés {tourney?.queAunNoAceptaste?.length}{' '}
                  {tourney?.queAunNoAceptaste?.length !== 1
                    ? 'solicitudes'
                    : 'solicitud'}
                </p>
              </Button>
            )}
          </div>
        )}
      </div>
      <Card className={cn('p-0 bg-white w-full pt-6 pb-3', {})}>
        <div className="flex items-center space-x-2 px-5">
          <figure>
            <img alt="Icono de titulo Desempeño del equipo" src={icPodium} />
          </figure>
          <p className="font-bold text-lg">Desempeño del equipo</p>
        </div>
        {/* card posicion en ... */}
        <CardPosition data={tourney?.puntajes} />
      </Card>
    </div>
  );
});

SidebarContentView.displayName = 'SidebarContentView';
